import { lrListofTrip } from '_services'
import { CommonCanvas } from 'components'
import { UserContext } from 'context'
import { utils } from 'helper'
import Loading from 'pages/Loading'
import React, { useContext, useEffect, useState } from 'react'
import StorageService from 'utils/StorageServices/StorageServices'
import { date } from 'yup'

const SelectLrForClaimInvoice = (props) => {
  const { masterData, allMenu } = useContext(UserContext);
    const [lrList,setLrList] = useState([])
    const [lrDetails,setLRDetails] = useState()
    const [lrFlag,setLrFlag] = useState(false)

    useEffect(()=>{
        getLrListOfTrip()
    },[])

    useEffect(()=>{
if(lrList?.length===1){
  props.callClaim(lrDetails)
  props.closeModal()
}
    },[lrList])

    const getLrListOfTrip = async (tripId) => {
      
        try {
          const res = await lrListofTrip({
            company_id: StorageService.getCompanyId(),
            trip_id: props?.tripId,
          });
 
          if (res?.responseCode === 200) {
            setLrList(res?.data?.lr_list);
           
            if(res?.data?.lr_list.length){
              setLrFlag(false)
            }else{
              setLrFlag(true)
            }
            if(res?.data?.lr_list.length===1){
              setLRDetails(res?.data?.lr_list[0])
            }
          } else {
            
          }
        } catch (error) {
        }
      };

      const onSubimt = async ()=> {
        props.callClaim(lrDetails)
        props.closeModal()
          
      }

      const modifyProps ={
        ...props,
        onSubmit:onSubimt,
        disabled:!lrDetails
      }

  return (
    <CommonCanvas {...modifyProps}>
    <div className="offcanvas-body">
                <div className='_lrCl_offCavBody'>

                  {lrList.length>0?<>
                    {lrList.map((i)=>{
                    return<div className={`_lrl_otrBx ${i?._id===lrDetails?._id?"selectedBxs":""}`} onClick={()=>setLRDetails(i)}>
                    <div className='_lr_cnpCode'>
                      <h4 className='_lrl_cnp'>{i?.consignor_id?.name}</h4>
                      <h4 className='_lrl_code'>#{i?.lr_number}</h4>
                    </div>

                    <div className='_lrlRout_ls'>
                      <div className='_lrHead_fsx'>
                        <h3>{i?.from_location}</h3>
                        <p>{utils.formatDateMonth(i.invoice_date)}</p>
                      </div>

                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="136" height="29" viewBox="0 0 136 29" fill="none">
                          <path d="M0 15L51 15" stroke="#DFE8FF" />
                          <path d="M85 15L136 15" stroke="#DFE8FF" />
                          <circle cx="67.5" cy="14.5" r="14.5" fill="#DFE8FF" />
                          <path d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z" fill="#1450EC" />
                        </svg>
                      </div>

                      <div className='_lrHead_fsx _lrs_rSide'>
                        <h3>{i?.to_location}</h3>
                      </div>
                    </div>

                    <div className='_lr_cnpCode'>
                      <h4 className='_lrl_code'>INV- {i?.invoice_number}</h4>

                      <p className='_lrl_stats'><span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                          <ellipse cx="5.54354" cy="5.5" rx="5.54354" ry="5.5" fill="#22A57A" />
                        </svg>
                      </span>  {" "}
                                      {masterData?.lr_status[i?.lr_status]
                                        ? masterData?.lr_status[i?.lr_status]
                                        : ""}{" "} </p>
                    </div>

                  </div>
                  })}
                  </>:lrFlag?(<>No Data</>):<>
                 <Loading/>
                  </>}

                </div>
              </div>
    </CommonCanvas>
  )
}

export default SelectLrForClaimInvoice